import api from './axios';

export const getDietPlan = (userId) => api.get(`/diet-plans/admin/${userId}`);
export const getDietPlanHistory = (userId) => api.get(`/diet-plans/admin/${userId}/history`);
export const createNewDietPlanVersion = (userId, sourcePlanId = null) => api.post(`/diet-plans/admin/${userId}/new-version`, sourcePlanId ? { sourcePlanId } : {});
export const deleteDietPlanDraft = (userId, planId) => api.delete(`/diet-plans/admin/${userId}/draft/${planId}`);
export const saveDietPlan = (userId, data) => api.put(`/diet-plans/admin/${userId}`, data);
export const submitAdminDietFeedback = (userId, text) => api.post(`/diet-plans/admin/${userId}/feedback`, { text });
export const getDietFeedback = (userId) => api.get(`/diet-plans/my/${userId}/feedback`);
// Generating a seven-day Iranian meal catalogue can take longer than the
// default admin API timeout; keep the rest of the panel fast.
export const generateDietPlan = (userId, settings = {}) => api.post(`/diet-plans/admin/${userId}/generate`, settings, { timeout: 150000 });
export const rebalanceDietPlan = (userId, data) => api.post(`/diet-plans/admin/${userId}/rebalance`, data, { timeout: 60000 });
export const getDietPlanInitialData = (userId) => api.get(`/diet-plans/admin/${userId}/initial-data`);
export const generateDietPlanPdf = (userId, data) => api.post(`/diet-plans/admin/${userId}/generate-pdf`, data, { timeout: 60000 });
export const uploadDietPlanPdf = (userId, file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post(`/diet-plans/admin/${userId}/pdf`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getNutritionKnowledgeBase = () => api.get('/diet-plans/knowledge-base');
export const saveNutritionKnowledgeBase = (data) => api.put('/diet-plans/knowledge-base', data);
